import React from 'react';

const Temperature = (props) => {
  const { info } = props;

  return <p className={info.class}>{info.temp.toFixed(0)}</p>;
};
export default Temperature;
